export { ResizeSensorComponent } from './resize-sensor.component';
export { ResizeBatchService } from './resize-batch.service';
export { ResizeSensorModule } from './resize-sensor.module';
